export const scrollOffset = (hash) => {
  switch (hash) {
    case '#hero':
      return 0;
    case '#skills':
      return -100;
    case '#experience':
      return -50;
    case '#projects':
      return -100;
    case '#testimonials':
      return -80;
    default:
      return 0;
  }
};
